import styled from 'styled-components'

export const GradientButton = styled.a`
background: linear-gradient(175.85deg, #0072CE -266.29%, #0075CD -78.97%, #0083C6 43.06%, #00A7B5 120.26%);
box-shadow: inset 0px -4px 4px rgba(0, 0, 0, 0.25);
`